import api from '../../../api/client';
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { Row, Col, Card, ListGroup, Table, Button } from "react-bootstrap";
// import ModuleNotification from "../../../components/Widgets/Statistic/Notification";
// import config from "../../../config";

// // import avatar1 from '../../../../assets/images/user/avatar-1.jpg';
// import avatar2 from "./../../../assets/images/user/avatar-2.jpg";
// // import avatar3 from "../../../../assets/images/user/avatar-3.jpg";
// // import avatar4 from '../../../../assets/images/user/avatar-4.jpg';

// import axios from "axios";

// const DetailsUser = () => {
//   const { id } = useParams();
//   const [userData, setUserData] = useState({});
//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;
//   const [userRoles, setUserRoles] = useState([]);
//   const [farmOptions, setFarmOptions] = useState([]);

//   useEffect(() => {
//     const fetchFarms = async () => {
//       try {
//         const response = await api.get(`/farm`);
//         const farmData = response.data;
//         const options = farmData.map((farm) => ({
//           value: farm.id,
//           label: farm.name,
//         }));

//         setFarmOptions(options);
//       } catch (error) {
//         console.error("Error fetching Farms:", error);
//       }
//     };

//     fetchFarms();
//   }, [apiUrl, farmOptions]);

//   useEffect(() => {
//     const fetchUserRoles = async () => {
//       try {
//         const response = await api.get(`/roles`);
//         const farmData = response.data;
//         const options = farmData.map((farm) => ({
//           value: farm.id,
//           label: farm.name,
//         }));
//         setUserRoles(options);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchUserRoles();
//   }, []);

//   useEffect(() => {
//     const getUser = async () => {
//       try {
//         const requestDoc = await api.get(`/auth/${id}`);
//         setUserData(requestDoc.data[0]);
//         //   console.log(requestDoc.data);
//       } catch (error) {
//         console.log("Error getting document:", error);
//       }
//     };
//     getUser();
//   }, [id]);

//   if (!userData) {
//     return <div>Loading...</div>;
//   }

//   const {
//     firstname,
//     lastname,
//     email,
//     id_number,
//     phone_number,
//     mpesa_number,
//     nssf,
//     nhif,
//     county,
//     address,
//     department,
//     position,
//     gender,
//     leave_days,
//     payment_rate,
//     emp_status,
//     is_admin,
//     is_active,
//     nok_firstname,
//     nok_lastname,
//     nok_email,
//     nok_phone_number,
//     nok_address,
//     createdAt,
//     farm,
//     id_card,
//     passport,
//     nssf_card,
//     nhif_card,
//     updatedAt,
//     hireDate,
//   } = userData;

//   const viewImage = (file) => {
//     if (file) {
//       window.open(`/uploads/${file}`, "_blank");
//     }
//   };

//   return (
//     <React.Fragment>
//       <Row>
//         <Col md={6} lg={4}>
//           <Card>
//             <Link to="/users/employees">
//               <Button variant="primary" className="mb-3 mt-2">
//                 <span className="feather icon-arrow-left"></span> Go Back
//               </Button>
//             </Link>
//             <Card.Header>
//               <Card.Title as="h5">User Profile</Card.Title>
//             </Card.Header>
//             <Card.Body>
//               <div className="row pro-head d-flex align-items-center justify-content-between border-bottom">
//                 <div className="col-12">
//                   {passport ? (
//                     <img
//                       src={`/uploads/${passport}`}
//                       className="img-radius"
//                       alt="User Passport"
//                       style={{
//                         width: "100px",
//                         height: "100px",
//                         borderRadius: "50%",
//                         marginBottom: "1.2rem",
//                         objectFit: "cover",
//                       }}
//                     />
//                   ) : (
//                     <img
//                       src={avatar2}
//                       className="img-radius"
//                       alt="User Profile"
//                     />
//                   )}
//                 </div>
//                 <div className="col pb-3">
//                   <span>
//                     {firstname} {lastname}
//                   </span>
//                 </div>
//                 <div className="col pb-3">
//                   <Link to="#" className="dud-logout ml-5" title="Logout">
//                     <span className="feather icon-log-out"></span> {is_active}
//                   </Link>
//                 </div>
//               </div>
//               <Card.Text as="h6"></Card.Text>
//               <ListGroup className="list-group-flush border-bottom">
//                 <div className="row d-flex align-items-center m-t-5 m-b-5">
//                   <div className="col-6">
//                     <p className="m-1">PHONE NUMBER:</p>
//                     <p className="m-1">ID NUMBER:</p>
//                     <p className="m-1">EMAIL:</p>
//                     <p className="m-1">DEPARTMENT:</p>
//                     <p className="m-1">POSITION:</p>
//                     <p className="m-1">GENDER:</p>
//                     <p className="m-1">HIRED:</p>
//                   </div>

//                   <div className="col-6 text-right">
//                     <p className="m-1">{phone_number || "-"}</p>
//                     <p className="m-1">{id_number || "-"}</p>
//                     <p className="m-1">{email || "-"}</p>
//                     <p className="m-1">{department || "-"}</p>
//                     <p className="m-1">{position || "-"}</p>
//                     <p className="m-1">{gender || "-"}</p>
//                     <p className="m-1">
//                       {new Date(hireDate).toDateString() || "-"}
//                     </p>
//                   </div>
//                 </div>
//               </ListGroup>
//             </Card.Body>
//           </Card>

//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Next of Kin</Card.Title>
//             </Card.Header>
//             <Card.Body>
//               <Table responsive hover striped>
//                 <tbody>
//                   <tr>
//                     <td>Next Of Kin Name:</td>
//                     <td>
//                       {nok_firstname} {nok_lastname}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>Next Of Kin Email:</td>
//                     <td>{nok_email}</td>
//                   </tr>
//                   <tr>
//                     <td>Next Of Kin Phone:</td>
//                     <td>{nok_phone_number}</td>
//                   </tr>
//                   <tr>
//                     <td>Next Of Kin Address:</td>
//                     <td>{nok_address}</td>
//                   </tr>
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={6} lg={8}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">User Details</Card.Title>
//             </Card.Header>
//             <Card.Body>
//               <Table responsive hover striped>
//                 <tbody>
//                   <tr>
//                     <td>Mpesa Number:</td>
//                     <td>{mpesa_number}</td>
//                   </tr>
//                   <tr>
//                     <td>NSSF:</td>
//                     <td>{nssf}</td>
//                   </tr>
//                   <tr>
//                     <td>NHIF:</td>
//                     <td>{nhif}</td>
//                   </tr>
//                   <tr>
//                     <td>County:</td>
//                     <td>{county}</td>
//                   </tr>
//                   <tr>
//                     <td>Address:</td>
//                     <td>{address}</td>
//                   </tr>
//                   <tr>
//                     <td>Leave:</td>
//                     <td>{leave_days} day(s)</td>
//                   </tr>
//                   <tr>
//                     <td>Payment Rate:</td>
//                     <td>{payment_rate}</td>
//                   </tr>
//                   <tr>
//                     <td>Employement Status:</td>
//                     <td>{emp_status}</td>
//                   </tr>
//                   <tr>
//                     <td>User Role:</td>
//                     <td>
//                       {userRoles.find((o) => o.value === is_admin)?.label}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>Created:</td>
//                     <td>{new Date(createdAt).toLocaleString()}</td>
//                   </tr>
//                   <tr>
//                     <td>Updated:</td>
//                     <td>{new Date(updatedAt).toDateString()}</td>
//                   </tr>
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//           <Card>
//             <Card.Body>
//               <Table responsive hover striped>
//                 <tbody>
//                   <tr>
//                     <td>Farm:</td>
//                     <td>{farmOptions.find((o) => o.value === farm)?.label}</td>
//                   </tr>
//                   <tr>
//                     <td>Passport Photo:</td>
//                     <td>
//                       {passport ? (
//                         <Button onClick={() => viewImage(passport)}>
//                           <i className="feather icon-download-cloud" /> View
//                         </Button>
//                       ) : (
//                         <Button variant="secondary" disabled>
//                           <i className="feather icon-slash" /> No Image
//                         </Button>
//                       )}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>ID Photo:</td>
//                     <td>
//                       {id_card ? (
//                         <Button onClick={() => viewImage(id_card)}>
//                           <i className="feather icon-download-cloud" /> View
//                         </Button>
//                       ) : (
//                         <Button variant="secondary" disabled>
//                           <i className="feather icon-slash" /> No Image
//                         </Button>
//                       )}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>Nhif Photo:</td>
//                     <td>
//                       {nhif_card ? (
//                         <Button onClick={() => viewImage(nhif_card)}>
//                           <i className="feather icon-download-cloud" /> View
//                         </Button>
//                       ) : (
//                         <Button variant="secondary" disabled>
//                           <i className="feather icon-slash" /> No Image
//                         </Button>
//                       )}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>Nssf Photo:</td>
//                     <td>
//                       {nssf_card ? (
//                         <Button onClick={() => viewImage(nssf_card)}>
//                           <i className="feather icon-download-cloud" /> View
//                         </Button>
//                       ) : (
//                         <Button variant="secondary" disabled>
//                           <i className="feather icon-slash" /> No Image
//                         </Button>
//                       )}
//                     </td>
//                   </tr>
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </React.Fragment>
//   );
// };

// export default DetailsUser;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  Row,
  Col,
  Avatar,
  Card,
  Tabs,
  Descriptions,
  Tag,
  Button,
  Space,
  Divider,
  Empty,
} from "antd";
import {
  UserOutlined,
  ArrowLeftOutlined,
  EyeOutlined,
  StopOutlined,
} from "@ant-design/icons";
import axios from "axios";
import config from "../../../config";
import MainCard from "../../../components/Card/MainCard";

const { TabPane } = Tabs;

const DetailsUser = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState({});
  const [userRoles, setUserRoles] = useState([]);
  const [farmOptions, setFarmOptions] = useState([]);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    const fetchFarms = async () => {
      try {
        const response = await api.get(`/farm`);
        setFarmOptions(
          response.data.map((farm) => ({ value: farm.id, label: farm.name })),
        );
      } catch (error) {
        console.error("Error fetching Farms:", error);
      }
    };
    fetchFarms();
  }, [apiUrl]);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await api.get(`/roles`);
        setUserRoles(
          response.data.map((role) => ({ value: role.id, label: role.name })),
        );
      } catch (error) {
}
    };
    fetchUserRoles();
  }, []);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await api.get(`/auth/${id}`);
setUserData(res.data[0]);
      } catch (error) {
}
    };
    getUser();
  }, [id, apiUrl]);

  if (!userData) return <Empty description="Loading user data..." />;

  const {
    firstname,
    lastname,
    email,
    id_number,
    phone_number,
    mpesa_number,
    nssf,
    nhif,
    county,
    address,
    department,
    position,
    gender,
    leave_days,
    payment_rate,
    emp_status,
    is_admin,
    is_active,
    nok_firstname,
    nok_lastname,
    nok_email,
    nok_phone_number,
    nok_address,
    createdAt,
    farm,
    id_card,
    passport,
    nssf_card,
    nhif_card,
    updatedAt,
    hireDate,
  } = userData;

  const viewImage = (file) => {
    if (file) window.open(`/uploads/${file}`, "_blank");
  };

  return (
    <Row gutter={16}>
      <Col xs={24} md={8}>
        <Card title="Profile" >
          <div style={{ textAlign: "center" }}>
            <Avatar
              size={120}
              src={passport ? `/uploads/${passport}` : null}
              icon={!passport && <UserOutlined />}
            />
            <h3 style={{ marginTop: 16 }}>
              {firstname} {lastname}
            </h3>
            <Tag color={is_active ? "green" : "red"}>
              {is_active ? "Active" : "Inactive"}
            </Tag>
            <Divider />
            <Button icon={<ArrowLeftOutlined />}>
              <Link to="/users">Back to Users</Link>
            </Button>
          </div>
        </Card>
      </Col>

      <Col xs={24} md={16}>
        <Card title="Employee Details" >
          <Tabs defaultActiveKey="1">
            {/* Profile Info */}
            <TabPane tab="Profile" key="1">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Phone">
                  {phone_number || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="ID">
                  {id_number || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                  {email || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Department">
                  {department || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Position">
                  {position || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Gender">
                  {gender || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Hired">
                  {hireDate ? new Date(hireDate).toDateString() : "-"}
                </Descriptions.Item>
              </Descriptions>
            </TabPane>

            {/* Employment Details */}
            <TabPane tab="Employment" key="2">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Mpesa">
                  {mpesa_number}
                </Descriptions.Item>
                <Descriptions.Item label="NSSF">{nssf}</Descriptions.Item>
                <Descriptions.Item label="NHIF">{nhif}</Descriptions.Item>
                <Descriptions.Item label="County">{county}</Descriptions.Item>
                <Descriptions.Item label="Address">{address}</Descriptions.Item>
                <Descriptions.Item label="Leave Days">
                  {leave_days}
                </Descriptions.Item>
                <Descriptions.Item label="Payment Rate">
                  {payment_rate}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  <Tag color={emp_status === "Employed" ? "blue" : "volcano"}>
                    {emp_status}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Role">
                  {userRoles.find((o) => o.value === is_admin)?.label || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Created">
                  {new Date(createdAt).toLocaleString()}
                </Descriptions.Item>
                <Descriptions.Item label="Updated">
                  {new Date(updatedAt).toDateString()}
                </Descriptions.Item>
                <Descriptions.Item label="Farm">
                  {farmOptions.find((o) => o.value === farm)?.label}
                </Descriptions.Item>
              </Descriptions>
            </TabPane>

            {/* Next of Kin */}
            <TabPane tab="Next of Kin" key="3">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Name">
                  {nok_firstname} {nok_lastname}
                </Descriptions.Item>
                <Descriptions.Item label="Email">{nok_email}</Descriptions.Item>
                <Descriptions.Item label="Phone">
                  {nok_phone_number}
                </Descriptions.Item>
                <Descriptions.Item label="Address">
                  {nok_address}
                </Descriptions.Item>
              </Descriptions>
            </TabPane>

            {/* Documents */}
            <TabPane tab="Documents" key="4">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  disabled={!passport}
                  onClick={() => viewImage(passport)}
                >
                  Passport
                </Button>
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  disabled={!id_card}
                  onClick={() => viewImage(id_card)}
                >
                  ID Card
                </Button>
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  disabled={!nhif_card}
                  onClick={() => viewImage(nhif_card)}
                >
                  NHIF Card
                </Button>
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  disabled={!nssf_card}
                  onClick={() => viewImage(nssf_card)}
                >
                  NSSF Card
                </Button>
              </Space>
            </TabPane>
          </Tabs>
        </Card>
      </Col>
    </Row>
  );
};

export default DetailsUser;
